import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { setRedirectUrl } from "./actions";
import { useSFDCAuthState } from "./useSFDCAuthState";

type Props = {
  children?: React.ReactNode;
};

const HandleRedirect = () => {
  const [, authDispatch] = useSFDCAuthState();
  const redirectUrl = React.useMemo(() => new URL(globalThis.location.href), []);

  React.useEffect(() => {
    if (redirectUrl.pathname.includes("oauth/")) return;
    authDispatch(setRedirectUrl(redirectUrl.pathname));
  }, [redirectUrl, authDispatch]);

  return <Navigate to="/oauth/login" replace />;
};

export const RequireSFDCAuth: React.FC<Props> = ({ children }: Props) => {
  const [authState] = useSFDCAuthState();

  const isWithTokenAndInitialized = React.useMemo(() => {
    return authState.sfdcAuthToken != null && authState.initialized;
  }, [authState.sfdcAuthToken, authState.initialized]);

  // Use Outlet for nested routes, fallback to children for direct wrapping
  return (
    <>
      {isWithTokenAndInitialized ? children || <Outlet /> : <HandleRedirect />}
    </>
  );
};
